export const STATUS_SUCCESS = 'authSuccess';
export const STATUS_ERROR = 'authError';
